export default "/_next/static/images/fa/group-fa08886b7e92e27cec3259ac535aa121.jpg";